import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DateTime } from 'luxon'
import {
	Wrapper,
	TimerHeading,
	CountdownContainer,
	CountdownWrapper,
	CountdownNumber,
	CountdownText,
} from './styles'

const UPDATE_INTERVAL_MS = 1000
const TIMER_UNITS = ['years', 'months', 'days', 'hours', 'minutes', 'seconds']

export const calculateElapsed = (date, now = DateTime.now()) => {
	const elapsed = now.setZone(date.zone).diff(date, TIMER_UNITS).toObject()
	return Object.fromEntries(
		TIMER_UNITS.map((unit) => [unit, Math.max(0, Math.floor(elapsed[unit]))]),
	)
}

function DateCountdown({ time }) {
	const { t } = useTranslation()
	const [elapsed, setElapsed] = useState(() => calculateElapsed(time))

	useEffect(() => {
		setElapsed(calculateElapsed(time))
		const interval = setInterval(() => {
			setElapsed(calculateElapsed(time))
		}, UPDATE_INTERVAL_MS)

		return () => clearInterval(interval)
	}, [time])

	return (
		<Wrapper aria-labelledby="wedding-timer-heading">
			<TimerHeading id="wedding-timer-heading">
				{t('weddingTimer.title')}
			</TimerHeading>
			<CountdownContainer>
				{TIMER_UNITS.map((unit) => (
					<CountdownWrapper key={unit}>
						<CountdownNumber>{elapsed[unit]}</CountdownNumber>
						<CountdownText>
							{t(`weddingTimer.${unit}`, { count: elapsed[unit] })}
						</CountdownText>
					</CountdownWrapper>
				))}
			</CountdownContainer>
		</Wrapper>
	)
}

DateCountdown.propTypes = {
	time: PropTypes.instanceOf(DateTime).isRequired,
}

export default DateCountdown
